import { Base } from "ui/Scripts/source/framework/base";
import { IUnitModuleNode } from "./unitModuleNode";
import { IUnitModuleNodeUsageSave, UnitModuleNodeUsageSave } from "./unitModuleNodeUsageSave";

export interface IUnitModuleNodeSave {
    id: string;
    parentId: string;
    name: string;
    comment: string;
    rowId: string;
    usages: IUnitModuleNodeUsageSave[];
}

export class UnitModuleNodeSave implements IUnitModuleNodeSave {
    id: string;
    parentId: string;
    name: string;
    comment: string;
    rowId: string;
    usages: UnitModuleNodeUsageSave[];

    constructor();
    constructor(obj: IUnitModuleNode);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.parentId = obj && obj.parent && obj.parent.id || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.rowId = obj && obj.rowId || "";
        this.usages = Base.getTypedArray(obj ? obj.usages : null, UnitModuleNodeUsageSave);
    }
}